/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
window.Vue = require("vue");

import VueSweetalert2 from "vue-sweetalert2";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);
export const Forma = new Vue({
  data() {
    return {
      payment_type_id: 1,
      office_start_id: {},
      office_stop_id: {},
      start_date: "",
      stop_date: "",
      start_time: "",
      stop_time: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      age: "",
      user_address: "",
      user_city: "",
      zip: "",
      baseprice: "",
      padresa: "",
      dadresa: "",
      lokacija: "",
      dlokacija: "",
      flight: "",
      price: ""
    };
  },
  created() {
    console.log("Listener instanciran");
  }
});

if (window.document.querySelector("#site")) {
  Vue.component("top-form", require("./components/site/TopForm.vue"));
  const app = new Vue({
    el: "#site",
    data() {
      return {};
    },
    mounted() {
      console.log("Site instanca");
    }
  });
  const modal = new Vue({
    el: "#modal",
    components: {
      "modal-form": require("./components/site/ModalForma.vue")
    },
    data() {
      return {};
    },
    mounted() {
      console.log("Modal instanca");
    }
  });

  const mail = new Vue({
    el: "#contact",
    components: {
      "mail-form": require("./components/site/MailSend.vue")
    },
    data() {
      return {};
    },
    mounted() {
      console.log("Modal instanca");
    }
  });
} else {
  console.log("query selector ne postoji");
}


// WEBPACK FOOTER //
// ./resources/assets/js/site.js